import i18n from 'helpers/i18n';
import messages from './messages';
import ModalInstructionItem from './ModalInstructionItem';
import lampIcon from 'images/reliabilityTest/lampIcon.svg';
import { Text } from '@teachstonellc/component-library';

function ModalContent({ testType }: { testType?: string }) {
  return (
    <div>
      {testType !== 'calibration' ? (
        <p>{i18n.ft(messages.threeAttempts)}</p>
      ) : null}
      <Text as="h3" className="py-4">
        {i18n.ft(messages.recommendations)}
      </Text>
      <ul>
        <li className="mb-4">
          <div className="flex items-start">
            <img src={lampIcon} className="inline mr-4" alt="" />
            {i18n.ft(messages.useClass)}
          </div>
        </li>
        {testType !== 'calibration' ? (
          <li className="mb-4">
            <div className="flex items-start">
              <img src={lampIcon} className="inline mr-4" alt="" />
              {i18n.ft(messages.code)}
            </div>
          </li>
        ) : null}
      </ul>
      <Text as="h3" className="py-4">
        {i18n.ft(messages.videoInstructions)}
      </Text>
      <ul className="mb-5">
        <ModalInstructionItem stepNumber="1" content={messages.useComputer} />
        <ModalInstructionItem
          stepNumber="2"
          content={messages.wearHeadphones}
        />
        <ModalInstructionItem
          stepNumber="3"
          content={
            testType === 'calibration'
              ? messages.calibration
              : messages.eachVideo
          }
        />
        <ModalInstructionItem
          stepNumber="4"
          content={
            testType === 'calibration'
              ? messages.onlyOnce
              : messages.watchedOnly
          }
        />
        <ModalInstructionItem
          stepNumber="5"
          content={
            testType === 'calibration'
              ? messages.takeNotes
              : messages.watchedOnly
          }
        />
        <ModalInstructionItem stepNumber="6" content={messages.classManual} />
        <ModalInstructionItem stepNumber="7" content={messages.enterCodes} />
      </ul>
    </div>
  );
}

export default ModalContent;
